import { useQuery } from "@tanstack/react-query"

import { PERSONAL_QUOTE_QUERY_KEY } from "@/constants/query"
import { getBulkOrders } from "@/http/bulkOrder"

import { IRequestParams } from "@/types/api"
import { BulkOrderStateRequest, BulkOrderStatus } from "@/types/IBulkOrder"

export const usePersonalOfferQuery = (params?: IRequestParams) => {
  return useQuery({
      queryFn: () => getBulkOrders(params || {}, BulkOrderStateRequest.PersonalOffer),
      queryKey: [PERSONAL_QUOTE_QUERY_KEY, params],
      retry: false
    })
}